import type { MessageV2Dto } from "@/api/types";
import { Breadcrumbs } from "@/components/Breadcrumbs/Breadcrumbs";
import { DocumentPaper } from "@/components/Paper/DocumentPaper";
import { useSlug } from "@/hooks/useSlug";
import { routes } from "@/routes";
import { useTranslation } from "@/translations";

import { CommunityPost } from "../List/components/CommunityPost/CommunityPost";

interface Props {
  message: MessageV2Dto;
}
export function PostDetails({ message }: Props): React.ReactNode {
  const slug = useSlug();
  const { t } = useTranslation();

  return (
    <DocumentPaper
      title={t("page.message-details.title")}
      subTitle={
        <Breadcrumbs
          pages={[
            {
              name: t("page.message-feed.title"),
              to: routes.messageFeed.list({
                slug,
              }),
            },
            {
              name: t("page.message-details.title"),
            },
          ]}
        />
      }
    >
      <CommunityPost message={message} isExpanded />
    </DocumentPaper>
  );
}
